import api from './api';

export interface Supplier {
    id: number;
    name: string;
    code?: string;
    created_at?: string;
    updated_at?: string;
}

export async function getSuppliers() {
    return api.get<{ data: Supplier[]; success: boolean }>('/suppliers');
}
